module.exports = __webpack_public_path__ + "static/gallery_peak_1_thumb-d124bfc869ffe5f7525ffd34fb9635dc.jpg";